import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { RaaRoles } from '../../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../../highorder/HasRolePrivileges';
import { selectRoomAlertDeviceList } from '../../../../../redux/slices/deviceList/deviceListSlice';

function NewAlertButton({ isLimitReached }) {
  const deviceList = useSelector(selectRoomAlertDeviceList);
  const HasRolePrivilegesConnected = HasRolePrivileges;
  const hasDevices = deviceList.filter((device) => !device.isSuspended).length > 0;

  return (
    <HasRolePrivilegesConnected targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
      <Link to="/s/alerts/new">
        <button
          type="button"
          className={`btn btn-primary ${isLimitReached && 'disabled'}`}
          disabled={isLimitReached || !hasDevices}
        >
          New Alert
        </button>
      </Link>
    </HasRolePrivilegesConnected>
  );
}

NewAlertButton.propTypes = {
  isLimitReached: PropTypes.bool.isRequired,
};

export default NewAlertButton;
